import React from 'react';
import IconTitleValue from "components/textValue/IconTitleValue";
import messages from "res/messages/farsi";
import {Divider} from "@mui/material";
import moment from "jalali-moment";
import Space from "components/space/Space";

import ICError from "res/images/error.png";
import ICSuccess from "res/images/success.png";

export default function OrderTransaction(props) {

    let transaction = props.transaction
    let showDivider = props.showDivider

    return (<div className="fullWidth marginSmall">
        {transaction &&
        <div>
            <div className="horizontalFullScreen">
                <div className="fullWidth">
                    <IconTitleValue
                        title={transaction.title}
                        titleClassName={transaction.payment_status === "3" ? "greenColor mediumTextBold" : "redColor mediumTextBold"}
                        icon={<img
                            src={transaction.payment_status === "3" ? ICSuccess : ICError}
                            alt="" className="smallIcon marginTopXSmall"/>}/>
                </div>
                <div className="marginLeftMedium">
                    <IconTitleValue
                        title={moment(transaction.date_added, 'HH:mm')
                            .locale('fa')
                            .format('HH:mm')}
                        titleClassName={"mediumTextBold marginTopBottomMedium"}
                        value={moment(transaction.date_added, 'YYYY/MM/DD')
                            .locale('fa')
                            .format('YYYY/MM/DD')}
                        valueClassName={"mediumTextBold marginTopBottomMedium"}/>
                </div>
            </div>
            <div className="horizontalFullScreen">
                <div className="fullWidth marginRightMedium">
                    <IconTitleValue
                        valueClassName={"mediumTextBold"}
                        title={messages.gateway}
                        value={transaction.gateway_title}/>
                </div>
                <div className="marginLeftMedium">
                    <IconTitleValue
                        title={messages.paymentCode}
                        valueClassName={"mediumTextBold"}
                        value={transaction.refrence_id}/>
                </div>
            </div>
            <Space height={"0.5em"}/>
            {showDivider &&
            <div style={{width: "80%", marginRight: "8%"}}>
                <Divider/>
            </div>
            }
        </div>
        }
    </div>)

}